__turbopack_context__.v({
  "caret": "SortDropdown-module-scss-module__yXRsUq__caret",
  "menu": "SortDropdown-module-scss-module__yXRsUq__menu",
  "option": "SortDropdown-module-scss-module__yXRsUq__option",
  "optionActive": "SortDropdown-module-scss-module__yXRsUq__optionActive",
  "positioner": "SortDropdown-module-scss-module__yXRsUq__positioner",
  "sortByLabel": "SortDropdown-module-scss-module__yXRsUq__sortByLabel",
  "sortGroup": "SortDropdown-module-scss-module__yXRsUq__sortGroup",
  "trigger": "SortDropdown-module-scss-module__yXRsUq__trigger",
});
